import type { ComponentPropsWithRef, ReactNode } from 'react'
import { Card } from '@/React/Shared/Component/Card'

export type SideFormSectionContainerProps = ComponentPropsWithRef<'div'>

export type SideFormSectionProps = SideFormSectionContainerProps

export function SideFormSectionContainer({
    children,
    className = '',
    ...restProps
}: SideFormSectionContainerProps) {
    return (
        <div
            {...restProps}
            className={`grid grid-cols-12 gap-4 md:gap-8 ${className}`.trim()}
        >
            {children}
        </div>
    )
}

export function SideFormSectionHeader({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={`col-span-12 md:col-span-4 space-y-2 ${className}`.trim()}
        >
            {children}
        </div>
    )
}

export function SideFormSectionTitle({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={`font-medium text-gray-700 ${className}`.trim()}
        >
            {children}
        </div>
    )
}

export function SideFormSectionSubtitle({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={`text-sm text-gray-600 ${className}`.trim()}
        >
            {children}
        </div>
    )
}

export interface SideFormSectionContentProps extends ComponentPropsWithRef<'div'> {
    children?: ReactNode
}

export function SideFormSectionContent({
    children,
    className = '',
    ...restProps
}: SideFormSectionContentProps) {
    return (
        <div
            {...restProps}
            className={`col-span-12 md:col-span-8 space-y-4 ${className}`.trim()}
        >
            <Card.Container>
                <Card.Content>{children}</Card.Content>
            </Card.Container>
        </div>
    )
}

export function SideFormSectionRawContent({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={`col-span-12 md:col-span-8 space-y-4 ${className}`.trim()}
        >
            {children}
        </div>
    )
}

export interface SideFormSectionDividerProps extends ComponentPropsWithRef<'div'> {}

export function SideFormSectionDivider({
    className = '',
    ...restProps
}: SideFormSectionDividerProps) {
    return (
        <div
            {...restProps}
            className={`col-span-12 py-10 ${className}`.trim()}
        >
            <div className="border-b border-b-gray-200"></div>
        </div>
    )
}

export const SideFormSection = Object.assign(SideFormSectionContainer, {
    Container: SideFormSectionContainer,
    Header: SideFormSectionHeader,
    Title: SideFormSectionTitle,
    Subtitle: SideFormSectionSubtitle,
    Content: SideFormSectionContent,
    RawContent: SideFormSectionRawContent,
    Divider: SideFormSectionDivider,
})
